import React, { ReactNode } from 'react';

import ShimmerBase from './styles';

export type Props = {
  circle?: boolean;
  width?: string;
  height?: string;
  fontSize?: string;
  children?: ReactNode;
};

const Shimmer = ({ children, ...props }: Props) => (
  <ShimmerBase {...props} aria-hidden role="presentation">
    {children}
  </ShimmerBase>
);

export default Shimmer;
